import cx from 'classnames'

type ChipColor = 'black' | 'black-yellow' | 'gray' | 'yellow'

interface ChipProps {
  color: ChipColor
  label: string
  className?: string
}

const Chip = ({ color, className, label }: ChipProps) => (
  <span
    className={cx(
      'py-1.5 px-1.5',
      'text-xxs leading-snug uppercase whitespace-nowrap pointer-events-none',
      {
        'bg-black text-white': color === 'black',
        'bg-black text-accent': color === 'black-yellow',
        'bg-gray text-pageText': color === 'gray',
        'bg-accent text-pageText': color === 'yellow',
      },
      className,
    )}
  >
    {label}
  </span>
)

export default Chip
